"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseError = void 0;
const types_1 = require("../../types");
/**
 * @class ResponseError - Thrown when a non 200 response was received from a fetch request.
 * @extends Error
 * @param {number} status - The status code of the response.
 * @param {string} message - The error message.
 * @param {RequestErrorKind} kind - The error kind.
 * @param {string} body - The response body.
 */
class ResponseError extends Error {
    constructor(status, message, kind = types_1.RequestErrorKind.UnknownException, body) {
        super(message);
        this.status = status;
        this.kind = kind;
        this.body = body;
    }
}
exports.ResponseError = ResponseError;
